










































































import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'StudioCommunityMembers',
  data() {
    return {
      search: '',
      tableFields: [
        {
          name: 'name',
          title: this.$t('COMMUNITY.TABLE.NAME'),
        },
        {
          name: 'status',
          title: this.$t('COMMUNITY.TABLE.STATUS'),
        },
        {
          name: 'actions',
          title: '',
          cssClass: 'p-0 custom-actions',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      group: 'community/currentGroup',
      userRole: 'user/role',
      isStudioOwner: 'user/isStudioOwner',
      currentUser: 'user/user',
    }),
    groupId(): number {
      return this.$route.params.group_id;
    },
    isTeacher() {
      return this.userRole == 'teacher';
    },
    query(): {} {
      return {
        groupId: this.groupId,
        studioURL: getStudioURL(this.$route),
        q: this.search,
      };
    },
  },
  methods: {
    viewProfile(data) {
      const route = this.$router.resolve({
        name: 'student-community-profile-view',
        params: { id: data?.id },
      });
      window.open(route.href, '_blank');
    },
    async banMember(groupId, member) {
      try {
        await this.$store.dispatch('community/banMember', {
          groupId,
          memberId: member.id,
        });
        member.is_banned = true;
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'COMMUNITY.NOTIFICATIONS.MEMBER_WAS_SUCCESSFULLY_BANNED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      }
    },
    async unBanMember(groupId, member) {
      try {
        await this.$store.dispatch('community/unBanMember', {
          groupId,
          memberId: member.id,
        });
        member.is_banned = false;
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'COMMUNITY.NOTIFICATIONS.MEMBER_WAS_SUCCESSFULLY_UNBANNED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      }
    },
    getStatus(value): string {
      return value.is_banned
        ? this.$t('COMMUNITY.TEXT.BANNED')
        : value.is_admin
        ? this.$t('COMMUNITY.TEXT.ADMIN')
        : this.$t('COMMUNITY.TEXT.MEMBER');
    },
    getCircleClass(value) {
      return value.is_banned
        ? 'status--banned'
        : value.is_admin
        ? 'status--admin'
        : 'status--member';
    },
    canBanUser(data) {
      return (
        (!data.is_admin && this.isTeacher) ||
        (this.isStudioOwner && data.id != this.currentUser.community_profile_id)
      );
    },
  },
});
